import { Grid, Skeleton } from '@mui/material'
import React from 'react'

const AssignedLoansSkeleton = () => {
    return (
        <div className='container-height-drawer'>
            <div className="content-container">
                <div className='drawer-content'>
                    <Grid container flexDirection={"column"} gap={"1.5rem"}>
                        <Grid item>
                            <Skeleton width={"100%"} height={150} sx={{ marginTop: "10px", transform: "unset" }} />
                        </Grid>
                        <Grid item sx={{ maxHeight: "65%", overflowY: "auto" }}>
                            <Skeleton width={"100%"} height={100} sx={{ marginTop: "10px", transform: "unset" }} />
                            <Skeleton width={"100%"} height={100} sx={{ marginTop: "10px", transform: "unset" }} />
                            <Skeleton width={"100%"} height={100} sx={{ marginTop: "10px", transform: "unset" }} />
                            <Skeleton width={"100%"} height={100} sx={{ marginTop: "10px", transform: "unset" }} />
                        </Grid>
                    </Grid>
                </div>
            </div>

        </div>
    )
}

export default AssignedLoansSkeleton